import { Users, Target, HeartHandshake, ShieldCheck, Scale, BookOpen } from "lucide-react";
import { PageHero, Eyebrow, PrimaryButton } from "@/components/Ui";
import { IMAGES } from "@/data/content";

const VALUES = [
  { icon: ShieldCheck, t: "Tutela", d: "Difendiamo i diritti del personale scolastico con competenza e determinazione." },
  { icon: HeartHandshake, t: "Assistenza", d: "Accompagniamo ogni assistito in tutte le fasi delle procedure amministrative." },
  { icon: BookOpen, t: "Formazione", d: "Percorsi qualificati per crescere professionalmente e aumentare il punteggio." },
];

const COLLABORATORI = [
  { role: "Consulenti sindacali", d: "Esperti nelle procedure di GPS, mobilità, concorsi e ricostruzione di carriera." },
  { role: "Operatori CAF e Patronato", d: "Specialisti in ISEE, 730, NASpI, pensioni e prestazioni INPS." },
  { role: "Referenti della formazione", d: "Tutor per CFU, TFA sostegno, master e certificazioni linguistiche e informatiche." },
];

const ChiSiamo = () => (
  <div data-testid="chi-siamo-page">
    <PageHero eyebrow="Chi siamo" title="Un punto di riferimento per la scuola" subtitle="Esperienza, competenza e vicinanza al personale scolastico in ogni fase della carriera." />

    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <Eyebrow>La nostra missione</Eyebrow>
          <h2 className="mt-3 font-serif text-4xl md:text-5xl font-medium text-navy-900 tracking-tight">Assistenza, tutela e formazione</h2>
          <p className="mt-6 text-slate-600 leading-relaxed">
            Palumbo Academy nasce con l'obiettivo di offrire assistenza, tutela e formazione al personale della scuola. Grazie a un'esperienza consolidata nel settore scolastico e sindacale, accompagniamo docenti, personale ATA, educatori e aspiranti lavoratori della scuola nelle principali procedure amministrative, contrattuali e professionali.
          </p>
          <p className="mt-4 text-slate-600 leading-relaxed">
            Ogni assistito trova in noi un interlocutore competente e affidabile, capace di semplificare procedure complesse e di garantire la piena tutela dei propri diritti.
          </p>
        </div>
        <img src={IMAGES.consulting2} alt="Il nostro team" className="w-full h-[440px] object-cover" />
      </div>
    </section>

    {/* Leader */}
    <section className="bg-navy-900 py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 noise-overlay opacity-[0.05]" />
      <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
        <div className="w-28 h-28 mx-auto bg-gold-500 flex items-center justify-center">
          <Users className="w-14 h-14 text-navy-900" />
        </div>
        <h2 className="mt-8 font-serif text-4xl md:text-5xl font-semibold text-white">Prof. Riccardo Palumbo</h2>
        <div className="mt-2 text-gold-500 uppercase tracking-[0.2em] font-bold text-sm">Dirigente Sindacale · Segretario Nazionale</div>
        <p className="mt-8 text-white/75 leading-relaxed max-w-3xl mx-auto text-lg">
          Alla guida di Palumbo Academy, il Prof. Riccardo Palumbo mette a disposizione una profonda conoscenza del mondo scolastico e sindacale, ponendo al centro la tutela e la crescita professionale del personale della scuola.
        </p>
      </div>
    </section>

    {/* Values */}
    <section className="bg-[#F8F9FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl"><Eyebrow>I nostri valori</Eyebrow><h2 className="mt-3 font-serif text-4xl md:text-5xl font-medium text-navy-900">Ciò in cui crediamo</h2></div>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {VALUES.map((v, i) => (
            <div key={v.t} data-testid={`value-${i}`} className="bg-white border border-gray-100 p-8 shadow-crisp">
              <div className="w-12 h-12 bg-navy-900 flex items-center justify-center mb-5"><v.icon className="w-6 h-6 text-gold-500" /></div>
              <h3 className="font-serif text-2xl font-semibold text-navy-900">{v.t}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Collaboratori */}
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl"><Eyebrow>Collaboratori e consulenti</Eyebrow><h2 className="mt-3 font-serif text-4xl md:text-5xl font-medium text-navy-900">Un team al tuo servizio</h2></div>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {COLLABORATORI.map((c, i) => (
            <div key={c.role} data-testid={`collab-${i}`} className="border-l-2 border-gold-500 pl-6 py-2">
              <h3 className="font-serif text-xl font-semibold text-navy-900">{c.role}</h3>
              <p className="mt-2 text-slate-600 leading-relaxed">{c.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-12"><PrimaryButton href="https://book.heygoldie.com/PalumboAcademy">Prenota una consulenza</PrimaryButton></div>
      </div>
    </section>
  </div>
);

export default ChiSiamo;
